import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { ObservationTypeValues } from 'src/app/model/enum/observation-type-values.enum';
import { MessagingService } from 'src/app/services/messaging/messaging.service';
import { ObservationCommentService } from '../../observation-comments/services/observation-comment/observation-comment.service';

@Component({
    selector: 'paetep-notify-of-comment',
    templateUrl: './notify-of-comment.component.html',
    styleUrls: ['./notify-of-comment.component.scss']
})
export class NotifyOfCommentComponent implements OnInit {
    @Input() observationType?: ObservationTypeValues;
    @Input() observationId?: string;
    @Input() observationTargetUserId?: string;
    @Input() receivingUserIds: (string | undefined)[] = [];

    constructor(
        private messageService: MessagingService, 
        private stateService: StateService,
        private toastr: ToastrService,
        private observationCommentService?: ObservationCommentService
    ) { }

    ngOnInit(): void {
    }

    public isDisabled() {
        return this.observationCommentService?.filters?.isReadOnly;
    }

    notifyOfCommentClicked = () => {
        const filteredReceivingUserIds = <string[]>this.receivingUserIds.filter(r => !!r);
        const link = this.stateService.href('.', {}, { absolute: true });

        if (this.observationType && this.observationId && filteredReceivingUserIds.length > 0 && this.observationTargetUserId) {
            firstValueFrom(
                this.messageService.notifyOfComment({
                    receivingUserIds: filteredReceivingUserIds,
                    observationUserId: this.observationTargetUserId,
                    observationId: this.observationId,
                    observationType: this.observationType,
                    link
                })
            ).then(() => {
                this.toastr.success('Notification of Comment Sent.', 'Success');
            });
        }
    } 
}
